import { render, staticRenderFns } from "./unicorn.vue?vue&type=template&id=488b687e&"
import script from "./unicorn.vue?vue&type=script&lang=js&"
export * from "./unicorn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports